import { ColorsList } from "@/src/components/colorsListPicker";
import { Input } from "@/src/components/universalInput";
import { AppointmentType, examCategoriesIds } from "@/src/data/allTypes";
import { getItemId, getUserId, isCabinet } from "@/src/utils/utils";
import { useState } from "react";
import { AppointmentTypeUsersList } from "../admin/referentiel/appointmentTypeUsersList";
import { ReferencePicker } from "../admin/referentiel/referencePicker";
import { ReorderableReferenceChildren } from "../admin/referentiel/reorderableReferenceChildren";

export function AppointmentTypeForm({
  current,
  onChange,
}: {
  current?: AppointmentType;
  onChange: (newValue: AppointmentType) => void;
}) {
  let [appointmentType, setAppointmentType] = useState(
    current || ({} as AppointmentType)
  );
  function setNewValue(newValue: AppointmentType) {
    setAppointmentType(newValue);
    onChange(newValue);
  }

  function isDefaultConsultation(
    appointmentType: AppointmentType | null | undefined
  ) {
    return (
      appointmentType?.name?.toLowerCase() == "consultation" &&
      getItemId(appointmentType?.creator) == getUserId()
    );
  }

  if (isDefaultConsultation(appointmentType)) {
    return (
      <div className="grid c1 gap20">
        <Input
          name={"Durée"}
          type={"select"}
          options={[
            { value: "15", label: "15 minutes" },
            { value: "30", label: "30 minutes" },
            { value: "45", label: "45 minutes" },
            { value: "60", label: "1 heure" },
            { value: "75", label: "1 heure 15" },
            { value: "90", label: "1 heure 30" },
            { value: "90", label: "1 heure 45" },
            { value: "120", label: "2 heures" },
            { value: "180", label: "3 heures" },
            { value: "240", label: "4 heures" },
          ]}
          value={appointmentType.duration}
          onChange={(newValue) => {
            setNewValue({ ...appointmentType, duration: newValue });
          }}
        />
        <Input
          name={"Prix"}
          type={"number"}
          value={appointmentType.price}
          onChange={(newValue) => {
            setNewValue({ ...appointmentType, price: parseInt(newValue) });
          }}
        />
      </div>
    );
  }

  return (
    <div className="grid c1 gap20">
      <Input
        name={"Nom"}
        type={"text"}
        value={appointmentType.name}
        onChange={(newValue) => {
          setNewValue({ ...appointmentType, name: newValue });
        }}
      />

      <Input
        name={"Durée"}
        type={"select"}
        options={[
          { value: "15", label: "15 minutes" },
          { value: "30", label: "30 minutes" },
          { value: "45", label: "45 minutes" },
          { value: "60", label: "1 heure" },
          { value: "75", label: "1 heure 15" },
          { value: "90", label: "1 heure 30" },
          { value: "90", label: "1 heure 45" },
          { value: "120", label: "2 heures" },
          { value: "180", label: "3 heures" },
          { value: "240", label: "4 heures" },
        ]}
        value={appointmentType.duration}
        onChange={(newValue) => {
          setNewValue({ ...appointmentType, duration: newValue });
        }}
      />
      <Input
        name={"Prix"}
        type={"number"}
        value={appointmentType.price}
        onChange={(newValue) => {
          setNewValue({ ...appointmentType, price: parseInt(newValue) });
        }}
      />
      <Input
        name={"Type"}
        type={"chips"}
        value={appointmentType.itemType}
        options={
          isCabinet()
            ? [
                { value: "consultation", label: "Consultation" },
                { value: "exam", label: "Examen" },
              ]
            : [
                { value: "consultation", label: "Consultation" },
                { value: "exam", label: "Examen" },
                { value: "hospitalisation", label: "Hospitalisation" },
                { value: "cure", label: "Cure" },
                { value: "legal", label: "Legal" },
                { value: "anapath", label: "Anapath" },
              ]
        }
        onChange={(newValue) => {
          setNewValue({ ...appointmentType, itemType: newValue });
        }}
      />
      {appointmentType.itemType == "exam" && (
        <ReferencePicker
          categories={examCategoriesIds}
          current={appointmentType.exam}
          title="Examen"
          onChange={(newValue) => {
            setNewValue({ ...appointmentType, exam: newValue });
          }}
        ></ReferencePicker>
      )}

      {!isCabinet() && (
        <>
          <ReferencePicker
            title="Formulaire de demande"
            categories={["formulaire"]}
            current={appointmentType.demandForm}
            onChange={(newValue) => {
              setNewValue({ ...appointmentType, demandForm: newValue });
            }}
          ></ReferencePicker>

          <Input
            name={"Doit être validé ?"}
            type={"chips"}
            options={[
              { value: "true", label: "Oui" },
              { value: "false", label: "Non" },
            ]}
            value={appointmentType.needsValidation == true ? "true" : "false"}
            onChange={(newValue) => {
              setNewValue({
                ...appointmentType,
                needsValidation: newValue === "true",
              });
            }}
          />

          <Input
            name={"External ID (API)"}
            type={"text"}
            value={appointmentType.externalId}
            onChange={(newValue) => {
              setNewValue({ ...appointmentType, externalId: newValue });
            }}
          />
          <ReorderableReferenceChildren
            label={"Préparations"}
            current={appointmentType.preparations || []}
            categories={["appointmentPreparation"]}
            onChange={(newValue) => {
              setNewValue({ ...appointmentType, preparations: newValue });
            }}
          />

          {appointmentType.id && (
            <AppointmentTypeUsersList
              permissionType="canScheduleTypes"
              appointmentType={appointmentType}
            ></AppointmentTypeUsersList>
          )}
          {appointmentType.id && (
            <AppointmentTypeUsersList
              permissionType="canValidateTypes"
              appointmentType={appointmentType}
            ></AppointmentTypeUsersList>
          )}
        </>
      )}

      <ColorsList
        label={"Couleur"}
        value={appointmentType.color}
        onChange={(newValue) => {
          setNewValue({ ...appointmentType, color: newValue });
        }}
      />
    </div>
  );
}
